
export default {
  name: 'FooterComponent',
  computed: {
    year() {
      return new Date().getFullYear();
    }
  },
}
